module.exports = __webpack_public_path__ + "static/bandai-namco-04c2177397fbdf651cb6281986be96aa.png";